import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledSearch,
  StyledInput,
  StyledButtonSearch,
  StyledIconSearch
} from './SearchHeaderTopStyle';

import { Search } from '../../../../assets/images';

const SearchHeaderTop = ({
  onChangeSearch,
  value,
  onFocus,
  onToggleSearch
}) => {
  const txtPlaceholder = `Buscar`;

  return (
    <StyledSearch>
      <StyledButtonSearch onClick={onToggleSearch}>
        <StyledIconSearch svg={Search} hover />
      </StyledButtonSearch>
      <StyledInput
        placeholder={txtPlaceholder}
        type="text"
        name="search"
        value={value}
        onChange={onChangeSearch}
        onFocus={onFocus}
      />
    </StyledSearch>
  );
};

SearchHeaderTop.propTypes = {
  onChangeSearch: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  onToggleSearch: PropTypes.func
};

export default SearchHeaderTop;
